import React, { Component } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import AdvanceDataTable from "../UI/Table/AdvanceDataTable";
import { ADMIN_EMPLOYEE_LIST } from "../UI/Table/ColumnConst";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faSignInAlt,
  faEdit,
  faUserLock,
} from "@fortawesome/free-solid-svg-icons";
import EmptyImg from "../Dashboard/assets/img/create-project.png";
import { HOST_URL } from "../Dashboard/api/Api";
import { userloginDetails } from "../Utils/AdminAuth";
import Axios from "../../axios/Axios";
class EmployeeManagement extends Component {
  constructor() {
    const lStorage = userloginDetails();

    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const userType = lStorage.user.isAdmin;

    const AdminEmail = lStorage.user.username;
    const userPassword = lStorage.user.password;

    super();

    this.state = {
      user_id: userId,
      userType: userType,
      adminPassword: userPassword,
      AdminEmail: AdminEmail,
      token: userToken,
      allUserList: [],
      serchData: "",
      userCurrentStatus: "",
      successMessage: false,
      errorMessage: "",
      bgColor: "alert alert-success alert-dismissible",
    };
  }

  componentDidMount() {
    this.onserch();
  }

  onserch() {
    const url =
      this.state.userType === 'admin'
        ? `${HOST_URL}/employee_user_list.php`
        : `${HOST_URL}/admin_user_list.php`;

    // Create the params object
    const params =
      this.state.userType === 'admin'
        ? {
          user_id: this.state.user_id,
          method: 'retrieve',
          type: 'admin',
          token: this.state.token,
        }
        : {
          user_id: this.state.user_id,
          method: 'retrieve_reseller',
          type: this.state.userType,
          token: this.state.token,
        };

    Axios
      .post(url, params)
      .then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.setState({ allUserList: result.data });
          this.setState({ userCurrentStatus: result.data[0].is_active });
        } else {
          this.setState({
            successMessage: true,
            successBg: 'alert alert-danger alert-dismissible',
            errorMessage: result.message,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          successMessage: true,
          successBg: 'alert alert-danger alert-dismissible',
          errorMessage: 'Something went wrong. Please try again.',
        });
      });
  }


  searchUser() {
    if (this.state.serchData === "") {
      this.onserch();
      this.setState({
        successMessage: true,
        errorMessage: "Enter User Name ",
        bgColor: "alert alert-danger alert-dismissible",
      });
    } else {
      const url = `${HOST_URL}/employee_user_list.php`;

      const params = {
        user_id: this.state.user_id,
        method: "retrieve",
        type: "search",
        user_name: this.state.serchData,
        token: this.state.token,
      };

      Axios
        .post(url, params)
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.setState({
              successMessage: false,
              allUserList: result.data,
            });
          } else {
            this.setState({
              successMessage: true,
              errorMessage: result.message,
              bgColor: "alert alert-danger alert-dismissible",
            });
          }
        })
        .catch((error) => {
          console.error(error);
          this.setState({
            successMessage: true,
            errorMessage: "Something went wrong. Please try again.",
            bgColor: "alert alert-danger alert-dismissible",
          });
        });
    }
  }

  render() {

    return (
      <div className="wrapper">
        <AdminLeftMenu />
        <div className="main">
          <AdminHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className="row mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    {/* <strong> Employee Management</strong> Management{" "} */}
                    <strong>
                      {this.state.userType === 'admin' ? 'Employee Management' : 'Reseller Management'}
                    </strong>
                  </h3>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                  <div className="card flex-fill">
                    {/* <div className="card-header">
                      <h5 className="card-title mb-0">{this.state.userType === 'admin' ? 'Employee List' : 'Reseller List'}</h5>
                    </div> */}

                    <div className="card-body">
                      <div className="filter-option">
                        <h6 className="card-subtitle text-muted">Filter </h6>
                        <div className="row align-items-center mb-2">
                          <div className="col-md-8">
                            <div className="input-group">
                              <div className="input-group-text">
                                <FontAwesomeIcon icon={faSearch} />
                              </div>
                              <input
                                type="text"
                                onChange={(event) => {
                                  this.setState({
                                    serchData: event.target.value,
                                  });
                                }}
                                placeholder="Enter user id or name of users"
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <button
                              type="button"
                              onClick={() => this.searchUser()}
                              className="btn btn-primary btn-sm w-100"
                            >
                              Search
                            </button>
                          </div>

                          <div className="col-md-2">
                            <a className="btn btn-primary btn-sm w-100" href="/admin/add-employee">
                              Add New
                            </a>
                          </div>
                        </div>

                      </div>

                      {this.state.successMessage ? (
                        <div className={this.state.bgColor} role="alert">
                          <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          <div className="">{this.state.errorMessage}</div>
                        </div>
                      ) : null}

                      <AdvanceDataTable
                        // tableName={this.state.userType === 'admin' ? 'User List' : 'Reseller List'}
                        tableCell={ADMIN_EMPLOYEE_LIST}
                        tableData={this.state.allUserList}
                        isLoading={this.state.setIsLoading}
                        isError={this.state.ErrorResponse}
                        pagination={true}
                        filterstatus={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <AdminFooter />
        </div>
      </div>
    );
  }
}
export default EmployeeManagement;